<template>
  <div class="app-passivate-sim-card">
    <h2 class="text-3xl">
      <span class="uppercase"><abbr title="Subscriber Identity Module">Sim</abbr></span> sperren
    </h2>

    <div class="container-box">
      <div class="content-limiter">
        <slot name="txtBefore"></slot>
        <div></div>
        <slot name="txtAfter"></slot>

        <div class="app-stepper">
          <button @click="goBack()" class="button button--secondary">Zurück</button>
          <button @click="deactivate()" class="button button--primary">SIM sperren</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'PassivateSimCard',
  mixins: [slotProxy()],
  methods: {
    deactivate() {
      this.$emit('deactivate')
    },
    goBack() {
      history.back()
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
